module.exports = __webpack_public_path__ + "img/circle-trash.60f401e8.svg";